import axios from 'axios'
import { BUSCAR_OPCOES_FILTROS_ADESAO_PONTOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarOpcoesFiltroAdesaoPontos () {

  const url = `${URL}/configuracao-ponto/opcoes-filtro`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_OPCOES_FILTROS_ADESAO_PONTOS,
        payload: response

      })
  );
}
